import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import StyledEducationNavBg from './educationNavBg.style';

const EducationNavBg = ({ educationTopics, overlap = false }) => {
  const multipleTopics = Array.isArray(educationTopics) && educationTopics.length > 1;
  const topic = educationTopics && educationTopics.length === 1 && educationTopics[0].slug;

  return (
    <StyledEducationNavBg multipleTopics={multipleTopics} category={topic} overlap={overlap} />
  );
};

EducationNavBg.propTypes = {
  educationTopics: PropTypes.arrayOf(PropTypes.shape()),
  overlap: PropTypes.bool
};

const mapStateToProps = state => ({
  educationTopics: state.app.pageData.educationTopics
});

export default connect(mapStateToProps)(EducationNavBg);
